import { Component, Vue, Prop } from "vue-property-decorator";
import { TranslationModel, ProductModel, Variant, ProductEnvironmentDatabase } from "../../models/product";
import ProductEnvironmentDataBaseModal from "./ProductEnvironmentDataBaseModal";

@Component({
    components: {
        ProductEnvironmentDataBaseModal
    }
})
export default class ProductEnvironmentDataBase extends Vue {

    protected vm: any = {};
    protected environmentDatabases: ProductEnvironmentDatabase[] = [];
    protected showModal: boolean = false;
    protected selectedIndex: number = 0;
    private translations: TranslationModel;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
    }

    protected created() {
        this.environmentDatabases = JSON.parse(this.$attrs.environmentdatabases);
    }

    protected GetEnvironmentDataBasePopUpInfo(index: number = 0) {
        this.showModal = true;
        this.selectedIndex = index;
        document.body.classList.add("addedtocartscroll--hidden");
    }

    protected closeModal() {
        this.showModal = false;
        document.body.classList.remove("addedtocartscroll--hidden");
    }
}
